import { validatePermissions } from '@shared/permissions';

import type { AppMenuConfig, MenuItemConfig } from '../../../types';

export function mapper(menuConfig: AppMenuConfig[], userPermission: string[]): AppMenuConfig[] {
  const routes: AppMenuConfig[] = [];

  if (!menuConfig) {
    return [];
  }

  menuConfig.forEach((section) => {
    const items: MenuItemConfig[] = [];

    section.items.forEach((item) => {
      if (!item.url && !item.subMenu) return;
      const permissions = item.permission;
      const hasPermission =
        !permissions?.requiredPermission ||
        validatePermissions(permissions?.requiredPermission, userPermission, permissions?.operator);
      if (hasPermission && !item.subMenu) {
        items.push(item);
        return;
      }

      if (item.subMenu) {
        const subMenu = item.subMenu.filter(
          (subMenuItem) =>
            subMenuItem.url &&
            (!subMenuItem.permission?.requiredPermission ||
              validatePermissions(
                subMenuItem.permission?.requiredPermission,
                userPermission,
                subMenuItem.permission?.operator,
              )),
        );

        if (subMenu.length > 0) {
          items.push({
            ...item,
            subMenu,
          });
        }
      }
    });

    if (items.length > 0) {
      routes.push({
        section: section.section,
        items: items,
      });
    }
  });

  return routes;
}
